import "react-toastify/dist/ReactToastify.css";

import Advertisement from "../components/Advertisement";
import FeedbackCard from "./searchHelpers/FeedbackCard";
import SearchFunction from "./search function/SearchFunction";
import Alert from "./searchHelpers/Alert";
import SEO from "../components/SEO";

function Search() {
  return (
    <>
      <Advertisement/>
      <SEO 
        title="Search Study Materials - Engineering Notes & PYQs | ReferMe"
        description="Search and browse engineering study notes, previous year papers, and exam materials by branch, year, and subject. Find exactly what you need for your exams."
        keywords="search engineering notes, browse study materials, find PYQs, engineering exam prep, branch-wise notes, subject-wise study guide"
        url="/Search"
      >
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Search Engineering Study Materials",
          "description": "Search for engineering notes, PYQs, and study materials by branch and subject",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://referme.pixenstudio.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Search",
                "item": "https://referme.pixenstudio.in/Search"
              }
            ]
          }
        })}
        </script>
      </SEO>
      <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 text-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto space-y-10">
          <FeedbackCard />
          <Alert />
          <SearchFunction />
        </div>
      </div>
    </>
  );
}

export default Search;
